import {
	IFiltersDashboardIncidents,
	IIncidentCategorySummary,
} from 'types/VehicleIncidents';
import { useGetDashboardBreakdownStringQuery } from 'redux/api/vehicleIncidents';
import DashboardIncidentCategoryBreakdownCard from '../DashboardIncidentCategoryBreakdownCard';
import DashboardCard from '../DashboardCard';
import Heading from 'components/atoms/Heading';
import IncidentCategoriesAtAGlanceGraph from '../IncidentCategoriesAtAGlanceGraph';
import { filtersToQueryStringConverter } from 'utils/filters';

export interface IDashboardIncidentsMainFiltered {
	filters: IFiltersDashboardIncidents;
	pdfRef: React.RefObject<HTMLDivElement>;
	renderingPdf: boolean;
}

const DashboardIncidentsMainFiltered: React.FC<
	IDashboardIncidentsMainFiltered
> = ({ filters, pdfRef, renderingPdf }) => {
	const query = filtersToQueryStringConverter(filters);
	const { data } = useGetDashboardBreakdownStringQuery(query);
	const categories: IIncidentCategorySummary[] = data?.categories || [];
	const graphCategories = data?.graphCategories || [];
	const renderClasses = renderingPdf ? '' : 'max-h-[600px] overflow-y-auto';
	// @ts-ignore
	const extraFilters = Object.fromEntries([...new URLSearchParams(query)]);

	return (
		<div className={`pt-6 ${renderingPdf ? '' : 'max-h-[700px]'}`} ref={pdfRef}>
			<Heading type="h3" className="mb-4 text-[24px]">
				Filtered Results
			</Heading>
			<div className="flex space-x-[30px]">
				<div className="flex flex-col basis-2/5 min-w-[472px] items-stretch">
					<DashboardCard
						className={`basis-1/3 ${renderClasses} grow`}
						title="Incident Categories"
						total={data?.total}
						dividerColor="border-grey-200"
					>
						<DashboardIncidentCategoryBreakdownCard
							categories={categories}
							incidentPath="incidents"
							getExtraFilters={() => {
								return {
									...extraFilters,
									// add branch_name only if branch is present on extraFilters
									...(extraFilters?.branch
										? { branch_name: extraFilters?.branch }
										: {}),
								} as { [key: string]: string | number };
							}}
						/>
					</DashboardCard>
				</div>
				<div className="flex flex-col basis-3/5 min-w-[472px] items-stretch">
					<DashboardCard
						className="basis-2/3 max-h-[600px] min-h-[600px] overflow-y-auto"
						title="Incidents at a Glance"
						dividerColor="border-grey-200"
					>
						<IncidentCategoriesAtAGlanceGraph categoryData={graphCategories} />
					</DashboardCard>
				</div>
			</div>
		</div>
	);
};

export default DashboardIncidentsMainFiltered;
